import { Route, Routes } from 'react-router-dom';
import AuthViews from '../views/auth';
import { Logo } from '../components/Elements/Logo';

function AuthLayout() {
  return (
    <div className="d-flex justify-content-center align-items-center bg-white" style={{ height: '100vh' }}>
      <div className='auth-wrapper w-100 col-md-4 mx-auto' style={{ height: '430px' }}>
        <div className="d-flex justify-content-center align-items-center">
          <Logo />	
        </div>
        <Routes>
          <Route path="/*" element={<AuthViews />} />
        </Routes>
      </div>
    </div>
  );
}

export default AuthLayout;
